const indexItems = [
  { label: '热播剧集', icon: 'ri-tv-line', desc: '最新热播电视剧一网打尽', count: '328部' },
  { label: '院线大片', icon: 'ri-film-line', desc: '高清电影畅快观影', count: '1560部' },
  { label: '综艺娱乐', icon: 'ri-emotion-laugh-line', desc: '热门综艺天天更新', count: '892期' },
  { label: '动漫番剧', icon: 'ri-ghost-line', desc: '日漫国漫精彩不断', count: '2100+集' },
  { label: '纪录片', icon: 'ri-global-line', desc: '高分纪录片深度探索', count: '650部' },
  { label: '动作大片', icon: 'ri-flashlight-line', desc: '肾上腺素飙升体验', count: '890部' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', desc: '烧脑剧情等你破解', count: '470部' },
  { label: '喜剧合集', icon: 'ri-emotion-happy-line', desc: '笑到停不下来', count: '720部' },
  { label: '韩剧专区', icon: 'ri-heart-line', desc: '浪漫韩剧甜蜜来袭', count: '560部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">专题合集</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">精选分类导航，快速找到你想看的影视内容，涵盖电影、电视剧、综艺、动漫等多个品类</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {indexItems.map((item) => (
            <a
              key={item.label}
              href="#index"
              className="group flex items-start gap-3 p-4 md:p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-200 cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-colors duration-200">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.label}</h3>
                  <span className="text-xs text-primary-500 bg-primary-50 px-1.5 py-0.5 rounded whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}